export default __webpack_public_path__ + "static/media/verify_otp_confirm.6748c4f0.svg";